/**
 * Opt-in look of the shared spreadsheet pieces (SimpleSpreadsheetHeader / SimpleSpreadsheetBody /
 * DocumentTableToolbar / SortableHeader).
 *
 * "default"    — the app-wide look, unchanged (every screen that passes nothing).
 * "enterprise" — the normativ look (OSCard): card frame, 26px header cells, text-[11px],
 *                tabular numbers, blue open-row marker. Enabled only on the И&Р codebooks
 *                (/machines, /phase-types, /process-definitions, /subprocesses,
 *                /production-statuses) and their nested tables.
 *
 * Purely visual — no behaviour depends on it.
 */
export type SpreadsheetAppearance = "default" | "enterprise";

/** Outer card around toolbar + table (screen level). */
export const ENTERPRISE_TABLE_CARD_CLS =
  "w-full mt-6 relative rounded-lg shadow-md shadow-gray-300/40";

/** Horizontal overflow for the table; MasterDataLayout handles vertical page scrolling. */
export const ENTERPRISE_TABLE_WRAP_CLS =
  "overflow-x-auto w-full border border-gray-200 border-t-0 bg-white rounded-b-lg relative mb-0";

/** Toolbar strip = the card's title bar. */
export const ENTERPRISE_TOOLBAR_CLS =
  "min-h-[44px] px-3 py-1.5 rounded-t-lg flex items-center justify-between gap-2";

/** Extra classes for SortableHeader cells (its base already has border / centering / bold). */
export const ENTERPRISE_SORTABLE_TH_CLS =
  "border-gray-300 bg-gray-200 text-gray-700 text-[11px] h-[26px] align-middle hover:bg-gray-300/60";
